import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OrderEffects } from './store/effects/order.effects';
import { orderReducer } from './store/reducers/order.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('order', orderReducer),
    EffectsModule.forFeature([OrderEffects]),
  ],
})
export class OrderModule {}
